import { api } from '~/redux/api/createApi';
import { PilotId } from '~/types/PilotId';
import { User } from '~/types/User';

import { useCurrentUser } from './useCurrentUser';

export const useUsers = (): Record<PilotId, User> => {
  const currentUser = useCurrentUser();
  const clientId = currentUser?.client;

  const { data = {} } = api.endpoints.getAllUsers.useQueryState(clientId);
  return data as Record<PilotId, User>;
};
